export default __webpack_public_path__ + "static/media/870.fa8ce6d7.gif";